const CHECKBOX_STYLE = {
    CHECKBOX: 'checkbox',
    SWITCH: 'switch'
}

export default CHECKBOX_STYLE
